export const WORKING_DIRECTORY = 'working-directory'

export const availableSoftwareLink =
  'https://www.jetbrains.com/help/teamcity/cloud/supported-platforms-and-environments.html#JetBrains-Hosted+Agents'
